import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";

export function buildQrUrl(no_akaun) {
  const base = window.location.origin;
  // Prefer path param for cleanliness; fallback to query is also supported by QRPage
  return `${base}/qr/${encodeURIComponent(no_akaun)}`;
}

export default function QRGenerator({ no_akaun = "0000" }) {
  const url = buildQrUrl(no_akaun);
  return (
    <Box sx={{ p: 2, display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
      <Typography variant="h6">Imbas QR untuk ke halaman bayaran</Typography>
      <QRCodeCanvas value={url} size={200} includeMargin level="M" />
      <Typography variant="caption" sx={{ wordBreak: "break-all", textAlign: "center" }}>{url}</Typography>
    </Box>
  );
}

QRGenerator.propTypes = {
  no_akaun: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
